import renderGameModeScene from './render-game-mode-scene.js';

const gameModeScene = (canvas, state) => {
  // ======== 游戏模式选择场景渲染入口 ========
  renderGameModeScene(canvas, state);
};

export default gameModeScene;
